var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box"},[_c('div',{on:{"click":function($event){return _vm.$router.back()}}},[_c('svg-icon',{attrs:{"icon-class":"backIcon","class-name":"backIcon"}})],1),_c('img',{attrs:{"src":"https://wd-appdownload.oss-cn-beijing.aliyuncs.com/ss-pc/work-title-icon.png","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }